async function parseResponse(res) {
  const contentType = res.headers.get("content-type") || "";
  const isJson = contentType.includes("application/json");
  const payload = isJson ? await res.json() : await res.text();

  if (!res.ok) {
    const detail = isJson && payload ? payload.detail : null;
    const message =
      (isJson && payload && payload.message) ||
      (typeof detail === "string" && detail) ||
      (detail && typeof detail === "object" && (detail.error || JSON.stringify(detail))) ||
      (typeof payload === "string" && payload) ||
      `${res.status} ${res.statusText}`;
    throw new Error(message);
  }

  return payload;
}

export async function getOrgSettings(orgId) {
  if (!orgId) throw new Error("orgId is required");

  const res = await fetch(`/api/organizations/${orgId}/settings`, {
    method: "GET",
    credentials: "include",
    headers: { Accept: "application/json" },
  });

  return parseResponse(res);
}

export async function updateOrgSetting(orgId, settingName, settingValue) {
  if (!orgId) throw new Error("orgId is required");
  if (!settingName) throw new Error("settingName is required");

  const encodedName = encodeURIComponent(settingName);
  const res = await fetch(`/api/organizations/${orgId}/settings/${encodedName}`, {
    method: "PATCH",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ setting_value: settingValue }),
  });

  return parseResponse(res);
}

export async function createOrgSetting(orgId, settingName, settingValue) {
  if (!orgId) throw new Error("orgId is required");
  if (!settingName) throw new Error("settingName is required");

  const res = await fetch(`/api/organizations/${orgId}/settings`, {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      setting_name: settingName,
      setting_value: settingValue,
    }),
  });

  return parseResponse(res);
}

export async function generateSubsidiaries(orgId, companyName) {
  if (!orgId) throw new Error("orgId is required");
  if (!companyName) throw new Error("companyName is required");

  const res = await fetch(`/api/organizations/${orgId}/generate-subsidiaries`, {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ company_name: companyName }),
  });

  return parseResponse(res);
}

export async function deleteOrgSetting(orgId, settingName) {
  if (!orgId) throw new Error("orgId is required");
  if (!settingName) throw new Error("settingName is required");

  const encodedName = encodeURIComponent(settingName);
  const res = await fetch(`/api/organizations/${orgId}/settings/${encodedName}`, {
    method: "DELETE",
    credentials: "include",
    headers: { Accept: "application/json" },
  });

  return parseResponse(res);
}
